/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import { UnprovisionedCard, UnprovisionedInfo } from '../../homepage-card';
import mcLib from '../../../api/mc-lib';

function getInfoAboutAutomationStudio() {
  mcLib.logEvent('unprovisioned app info', 'automation studio');
  window.open('https://www.marketingcloud.com/products/marketing-automation', '_blank'); // eslint-disable-line no-undef
}

function UnprovisionedAutomationStudio(props) {
  return (
    <UnprovisionedCard className={props.className} heading={props.heading} icon={props.icon}>
      <UnprovisionedInfo
        buttonLabel={props.localizations['homepage.cards.unprovisioned.get_info_button']}
        description={props.localizations['homepage.cards.unprovisioned.automation_studio.description']}
        onButtonClick={getInfoAboutAutomationStudio}
        title={
          <FormattedMessage
            id="homepage.cards.unprovisioned.heading"
            values={{
              product_name: 'Automation Studio',
            }}
          />
        }
      />
    </UnprovisionedCard>
  );
}

UnprovisionedAutomationStudio.displayName = 'Unprovisioned Automation Studio Info';

UnprovisionedAutomationStudio.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  icon: PropTypes.node,
  localizations: PropTypes.object,
};

export default UnprovisionedAutomationStudio;
